import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import Box from "@material-ui/core/Box";
// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-react/views/componentsSections/loginStyle.js";

import "./Section.css";

const useStyles = makeStyles(styles);

export default function SectionLogin() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={4}>
            <Card>
              <form className={classes.form}>
                <CardHeader color="info" className={classes.cardHeader}>
                  <h4>I - Series</h4>
                </CardHeader>
                <p className={classes.divider}>
                  Intelligent Suites for Issurance
                </p>
                <CardBody>
                  <Box fontStyle="italic" m={1}>
                    I-series is an Intelligent Suites which is capabale to
                    enhance your User Experince, this is built for and only for
                    Insuance Companies to keep in of all the Features.
                  </Box>
                </CardBody>
                <CardFooter className={classes.cardFooter}>
                  <Button simple color="success" size="lg">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      color="primary"
                      href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=mehrotra.rachit.io@gmail.com"
                    >
                      <span>Email for info</span>
                    </a>
                  </Button>
                </CardFooter>
              </form>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={12} md={4}>
            <Card>
              <form className={classes.form}>
                <CardHeader color="info" className={classes.cardHeader}>
                  <h4>B - Series</h4>
                </CardHeader>
                <p className={classes.divider}>
                  Intelligent Suites for Banking
                </p>
                <CardBody>
                  <Box fontStyle="italic" m={1}>
                    B-series is an Intelligent Suites which is capabale to
                    enhance your User Experince, this is built for and only for
                    Banking Companies to keep in of all the Features.
                  </Box>
                </CardBody>
                <CardFooter className={classes.cardFooter}>
                  <Button simple color="success" size="lg">
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      color="primary"
                      href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=mehrotra.rachit.io@gmail.com"
                    >
                      <span>Email for info</span>
                    </a>
                  </Button>
                </CardFooter>
              </form>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
